import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_64gjnxjyb8: FaireBrandEntity = {
  token: "b_64gjnxjyb8",
  type: "brand",
  name: "Karrbear",
  avatarUrl:
    "https://cdn.faire.com/fastly/4dc424e9654ed128877b63064fc488a8d4b61c6c0a1535388130cfe993592fd3.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/4c11793344fbe89cddc23747bae1b9b3f1f17815b70c9ac50ec466df4a5938a3.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/4dc424e9654ed128877b63064fc488a8d4b61c6c0a1535388130cfe993592fd3.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4c11793344fbe89cddc23747bae1b9b3f1f17815b70c9ac50ec466df4a5938a3.jpeg",
  location: "Brooklyn, NY, USA",
  minimumOrderDollars: 69,
  rating: 3.8,
  reviewCount: 12,
  isInsider: true,
  description:
    "Our company is in the business of Fine and Fashion jewelry, manufacturing and designing jewelry for Over 10 years. Due to our bulk buying and expertise in manufacturing we can make jewelry at low cost but with the highest value offered GUARANTEED.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:57.587Z",
    importedBy: "entity-db-cli",
  },
};
